import React, { useState, useEffect } from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { isEmpty } from 'lodash';
import ErrorBoundary from 'components/ErrorBoundary';
import SearchContainer from './SearchContainer';
import InvoiceTable from './InvoiceTable';
import useAxios from 'hooks/useAxios';
import { onExport, getUpdatedFilter } from 'utils/helper';
import Drawer from 'components/Drawer';
import ManualInvoice from 'components/ManualInvoice';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { dateFormate } from 'utils/columns';
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

const initialFilterBySearch = {
  coveredEntityName: '',
  invoiceStatusName: '',
};

let initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: 'createdDate',
  order: 'desc',
  filters: [],
};

let selectedCoveredEntity = {};
let selectedInvoiceStatus = {};


const Invoice = (props) => {
  const { orgId } = props
  const API = useAxios();
  const [isOpenInvoice, setIsOpenInvoice] = useState(false);
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [ceID, setCoveredEntityID] = useState(-1);
  const [state, updateState] = useState({
    data: [],
    coveredEntity: [],
    loading: false,
    selectedEntity: '',
    coveredId: '',
    records: 0,
    reset: false,
  });

  const [invStartDate, setInvStartDate] = useState(null);
  const setState = (state) => updateState((pre) => ({ ...pre, ...state }));
  let { tenantID, coveredEntityID } = selectedCoveredEntity;
  let selectedCEId = window.selectedCoveredEntittyId.toString();
  const [colFilter, setColFilter] = useState([]);
  const [resetFlag, SetResetFlag] = useState(false);

  useEffect(() => {
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: 'createdDate',
      order: 'desc',
      filters: [],
    };
    setState({ data: [], records: 0 });
    selectedCoveredEntity = {};
    selectedInvoiceStatus = {};
    setIsOpenInvoice(false);
  }, []);

  useEffect(() => {
    onReset()
    setIsOpenInvoice(false);

  }, [orgId])


  const fetchInvoiceStartDate = async () => {
    try {
      let { tenantID, coveredEntityID } = selectedCoveredEntity;
      const { data } = await API.get(
        `/${tenantID}/invoice/getnextinvoicedate/${coveredEntityID}`,
        {
          hideLoader: true,
        });
      if (data) {
        let invDate = dateFormate(data);
        setInvStartDate(invDate);
      }
    }
    catch (error) {

    }
  }

  const fetchInvoices = async (pageDetails = {}, hasColumnFilter) => {
    setState({ loading: true });
    let filter = { ...pageDetails };

    if (hasColumnFilter) {
      filter.filters = [...initialFilters.filters, ...pageDetails.filters];
      initialFilters.filters = [...initialFilters.filters];
      initialFilters.currentPage = pageDetails.currentPage;
      initialFilters.pageSize = pageDetails.pageSize;
      initialFilters.orderBy = pageDetails.orderBy;
      initialFilters.order = pageDetails.order;
    } else {
      initialFilters = { ...initialFilters, ...pageDetails };
    }
    let { tenantID, coveredEntityID } = selectedCoveredEntity;
    try {
      const { data } = await API.post(
        `/${tenantID}/Invoice/All/${coveredEntityID}`,
        filter
      );
      if (data) {
        setState({
          data: data.items,
          records: data.totalRecords,
          loading: false,
        });
      } else {
        setState({
          data: [],
          records: 0,
          loading: false,
        });
      }
    } catch (error) {
      setState({ loading: false, data: [], records: 0 });
    }
  };

  const onSearchInvoice = async (filters) => {
    const { coveredEntityName, invoiceStatusName } = filters;
    initialFilters.filters = [];
    let ce = coveredEntityName.toString();
    if (coveredEntityName && !isEmpty(ce)) {
      initialFilters.filters = getUpdatedFilter(
        'coveredEntityID',
        parseInt(coveredEntityName),
        initialFilters
      );


      if (invoiceStatusName) {
        initialFilters.filters = getUpdatedFilter(
          'invoiceStatusID',
          parseInt(invoiceStatusName),
          initialFilters
        );
      }
      initialFilters.currentPage = 1;
      fetchInvoices(initialFilters);
      fetchInvoiceStartDate();
    }
  };


  const onManualSearch = async (filters) => {
    const { coveredEntityName, coveredEntityID, invoiceID } = filters;
    setCoveredEntityID(coveredEntityID);
    selectedCoveredEntity = filters;
    setIsOpenInvoice(true);
  }

  const onReset = () => {
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: 'createdDate',
      order: 'desc',
      filters: [],
    };
    setState({ data: [], reset: !state.reset, records: 0 });
    selectedCoveredEntity = {};
    SetResetFlag(true);
  };

  const handleExport = () => {
    let { tenantID, coveredEntityID } = selectedCoveredEntity;
    const { access_token } =
      JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Invoice/ExportAll/${coveredEntityID}?access_token=${access_token}`;
    onExport(action, initialFilters);
  };
  const handleExport2 = async () => {

    var additionalCriteria = {};
    let { tenantID, coveredEntityID } = selectedCoveredEntity;
    const invoiceexportfilters = {
      ...initialFilters,
      filters: [
        ...(initialFilters?.filters || []),
        ...(colFilter?.filters || [])
      ]
    };
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.CEId = coveredEntityID;
    //filterObj.CoveredEntityIDS = coveredEntityID;
    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "invoice";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(invoiceexportfilters);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };
  const onPageChange = (filter, hasFilter) => {
    if (hasFilter) {
      fetchInvoices(filter, true);
    } else {
      fetchInvoices(filter);
    }
  };

  // const handleSearchColumnFilters = async (columnFilters, filterCancel) => {

  //   if (filterCancel == true) { await fetchInvoices(columnFilters) }

  //   else if (filterCancel == false) { await fetchInvoices({ ...initialFilters, ...columnFilters }, true); }
  // };

  const handleSearchColumnFilters = async (columnFilters) => {
    await fetchInvoices(columnFilters, true);
    setColFilter(columnFilters);
  };


  const handleSearchColumnFilterss = async (columnFilters) => {
    await fetchInvoices(columnFilters, true);
    setColFilter(columnFilters);
  };

  const handleUpdateEntity = (entity) => {
    selectedCoveredEntity = entity;
    fetchInvoiceStartDate();
  };

  const handleInvoiceStatus = (invoiceStatus) => {
    selectedInvoiceStatus = invoiceStatus;
  };

  const refetch = (hasReset) => {
    setColFilter([]);
    if (hasReset) {
      initialFilters = {
        ...initialFilters,
        currentPage: 1,
      };
    }
    fetchInvoices(initialFilters);
  };


  const onHandleManualInvoice = () => {
    setIsOpenInvoice(!isOpenInvoice);
  }

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };

  return (
    <div>
      <Container fluid className='width_info'>
        <div className={collapseSider ? "mb-0" : "mb-3"}>
          <Card className='border-0 shadow-top' hidden={collapseSider}>
            <CardBody className='section-devider-border'>
              <ErrorBoundary>
                <SearchContainer
                  initialValue={initialFilterBySearch}
                  onSearch={onSearchInvoice}
                  onReset={onReset}
                  orgId={orgId}
                  onManualSearch={onManualSearch}
                  handleUpdateEntity={handleUpdateEntity}
                  handleInvoiceStatus={handleInvoiceStatus}
                  selectedCEId={selectedCEId}
                />
              </ErrorBoundary>
            </CardBody>
          </Card>
        </div>
        <Card>
          <CardBody className='pt-0'>
            <ErrorBoundary>
              <InvoiceTable
                data={state.data}
                loading={state.loading}
                onExport={handleExport2}
                filters={initialFilters}
                totalRecords={state.records}
                onPageChange={onPageChange}
                selectedCoveredEntity={selectedCoveredEntity}
                coveredEntityID={selectedCoveredEntity.coveredEntityID}
                tenantID={selectedCoveredEntity.tenantID}
                setLoading={(value) => setState({ loading: value })}
                refetch={refetch}
                onSearchColumnFilters={handleSearchColumnFilters}
                reset={state.reset}
                orgId={orgId}
                onManualSearch={onManualSearch}
                resetFlag={resetFlag}
                SetResetFlag={SetResetFlag}
                collapseSider={collapseSider}
                toggleSider={toggleSider}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>


      <Drawer
        direction='end'
        title='Manual Invoice'
        isOpen={isOpenInvoice}
        toggle={onHandleManualInvoice}
        size="lg"
      >
        <ManualInvoice coveredEntityID={ceID} tenantID={selectedCoveredEntity.tenantID}
          rcsFeeBase={selectedCoveredEntity.rcsFeeBase} rcsFee={selectedCoveredEntity.rcsFee} invoiceID={selectedCoveredEntity.invoiceID} onSearch={onSearchInvoice} selectedCoveredEntity={selectedCoveredEntity}
          toggle={onHandleManualInvoice} invStartDate={invStartDate}
        />
      </Drawer>

    </div>
  );
};

export default Invoice;